import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Note } from '../..';
export const title = 'Using Styled Components';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "using-styled-components"
    }}>{`Using Styled Components`}</h1>
    <p>{`If you'd prefer to use the Styled Components library instead of Emotion, you can import components from `}<inlineCode parentName="p">{`rebass/styled-components`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import { Box } from 'rebass/styled-components'

export default props =>
  <Box>
    Hello
  </Box>
`}</code></pre>
    <Note mdxType="Note">
The package will still install Emotion as a dependency, but it will not be included in the module or your application bundle.
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      